module.exports = __webpack_public_path__ + "img/img14.b8a4f89d.png";